import { render, staticRenderFns } from "./il-language-selection.vue?vue&type=template&id=47a739ee&scoped=true"
import script from "./il-language-selection.vue?vue&type=script&lang=ts"
export * from "./il-language-selection.vue?vue&type=script&lang=ts"
import style0 from "./il-language-selection.vue?vue&type=style&index=0&id=47a739ee&prod&scoped=true&lang=scss"


/* normalize component */
import normalizer from "!../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "47a739ee",
  null
  
)

export default component.exports